<div class="mx-auto px-4">
  <div class="hidden md:block overflow-x-auto">
    <div class="mb-4">
      <p id="gestion-des-organisations" class="titre1 mt-4">{{
        'ORGANIZATIONS_MANAGEMENT.ORGANIZATIONS_MANAGEMENT' | translate }}
        <mat-icon
        class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-[30px] float-right">factory</mat-icon>
      </p>
    </div>

    @if (isLoading) {
      <div class="flex justify-center items-center h-64">
        <mat-spinner color="accent"></mat-spinner>
      </div>
    }

    @if (!isLoading) {
      <div class="flex items-end justify-end mb-4 gap-3">
        <mat-select [(ngModel)]="selectedGroupId" (selectionChange)="filtre()"
          placeholder="{{ 'ORGANIZATIONS_MANAGEMENT.ALL_GROUPS' | translate }}"
          class="w-1/5 h-8 max-w-[210px] border border-gray-300 rounded-md px-3 py-1" panelWidth="320"
          panelHeight="100">
          <mat-option>
            <ngx-mat-select-search [formControl]="groupFilterCtrl"
              [placeholderLabel]="'ORGANIZATIONS_MANAGEMENT.SEARCH' | translate"
              [noEntriesFoundLabel]="'ORGANIZATIONS_MANAGEMENT.NO_RESULTS' | translate">
            </ngx-mat-select-search>
          </mat-option>
          <mat-option [value]="null"> {{ 'ORGANIZATIONS_MANAGEMENT.ALL_GROUPS' | translate}}</mat-option>
          @for (groupe of filteredGroupes | async; track groupe) {
            <mat-option
              [value]="groupe.entiteId">{{groupe.nom}} @if (!groupe.estActif) {
              <span class="text-xs text-gray-500 m-2">({{ 'ENTITE_INACTIF' | translate }})</span>
            }</mat-option>
          }
        </mat-select>
        <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="filtre()"
          placeholder="{{ 'ORGANIZATIONS_MANAGEMENT.SEARCH' | translate }}..."
          class="h-8 w-46 rounded-md border-w-2 border-gray-300 shadow-sm focus:border-red-300 focus:ring focus:ring-red-200">
          <button mat-icon-button (click)="reinitialiserFiltre()" class="h-1/12 w-8 bg-white-200 text-white-600 rounded">
            <mat-icon>restore</mat-icon>
          </button>
        </div>
        <table mat-table [dataSource]="dataSource" matSort class="mat-table-novo">
          <ng-container matColumnDef="nom">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell w-2/5 px-4 py-2"> {{
            'ORGANIZATIONS_MANAGEMENT.NAME' | translate }} </th>
            <td mat-cell *matCellDef="let element" class="table-cell w-2/5 px-4 py-2 border-b">
              {{ element.nom }} @if (!element.estActif) {
              <span class="text-xs text-gray-500 m-2">({{ 'ENTITE_INACTIF' | translate }})</span>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="entiteId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell w-1/10 px-4 py-2"> {{
          'ORGANIZATIONS_MANAGEMENT.NOVO_ENTITY_ID' | translate }}</th>
          <td mat-cell *matCellDef="let element" class="table-cell w-1/10 px-4 py-2 border-b">
            {{ element.entiteId }}
          </td>
        </ng-container>
        <ng-container matColumnDef="neq">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell w-2/10 px-4 py-2">{{
          'ORGANIZATIONS_MANAGEMENT.NEQ' | translate }}</th>
          <td mat-cell *matCellDef="let element" class="table-cell w-2/10 px-4 py-2 border-b">
            {{ element.neq }}
          </td>
        </ng-container>
        <ng-container matColumnDef="idUnique">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell w-3/10 px-4 py-2">{{
          'ORGANIZATIONS_MANAGEMENT.UNIQUE_ID' | translate }}</th>
          <td mat-cell *matCellDef="let element" class="table-cell w-3/10 px-4 py-2 border-b">
            {{ element.idUnique }}
          </td>
        </ng-container>
        <ng-container matColumnDef="group">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell w-1/5 px-4 py-2">{{
          'ORGANIZATIONS_MANAGEMENT.GROUP' | translate }}</th>
          <td mat-cell *matCellDef="let element" class="table-cell w-1/5 px-4 py-2 border-b">
            {{ getGroupName(element.groupeId) }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let element; columns: displayedColumns;"></tr>
      </table>
      @if (dataSource.filteredData.length === 0) {
        <div class="text-center mt-2 text-gray-500">
          {{ 'COMMUN.DATATABLE_AUCUN_RESULTAT' | translate }}
        </div>
      }
      <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [pageIndex]="pageIndex"
        (page)="paginer($event)" [length]="totalItems" [showFirstLastButtons]="true">
      </mat-paginator>
    }
  </div>
</div>